import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "../../../utils/api/axios";
import {AuthContext} from "../../../utils/contextapi/AuthProvider";
import {CLIENT_ID, CLIENT_SECRET, IAM_MFA_OTP, NONCE, OAUTH, OAUTH_AUTHORIZE, OAUTH_TOKEN, REDIRECT_URI, RESPONSE_TYPE, SCOPE, STATE} from "../../../utils/Config";
import styles from './AuthEmail.module.css';

/**
 * OTP 테스트 페이지
 * @returns {JSX.Element}
 * @constructor
 */
function AuthEmail() {
    const location = useLocation();
    const movePage = useNavigate();

    const [authStatus, setAuthStatus] = useState('VERIFYING'); // 'VERIFYING', 'SUCCESS', 'FAILURE'
    const [message, setMessage] = useState('로그인 링크를 확인 중입니다...');
     

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (!token) {
            setAuthStatus('FAILURE');
            setMessage('유효하지 않은 링크입니다.');
            return;
        }

        const verifyToken = async () => {
            try {
                const response = await axios.get(`${IAM_MFA_OTP}/email/verify?token=${token}`);

                // 서버에서 응답 받은 데이터 구조에 따라 수정
                if (response.status === 200 && response.data.data) {

                    setAuthStatus('SUCCESS');
                } else {
                    setAuthStatus('FAILURE');
                    setMessage('유효하지 않거나 만료된 링크입니다.');
                }
            } catch (error) {
                setAuthStatus('FAILURE');
                setMessage('유효하지 않거나 만료된 링크입니다. 다시 로그인 시도해 주세요.');
            }
        };

        verifyToken();
    }, [location]);

    // 🔑 로그인 성공 시 5초 후 자동 리디렉션 로직
    useEffect(() => {
        if (authStatus === 'SUCCESS') {
            // const timer = setInterval(() => {
            //     setCountdown(prev => prev - 1);
            // }, 1000);

            // const redirectTimer = setTimeout(() => {
            //     movePage('/account/manage');
            // }, 5000);

            // return () => {
            //     clearInterval(timer);
            //     clearTimeout(redirectTimer);
            // };
        }
    }, [authStatus, movePage]);

    if (authStatus === 'VERIFYING') {
        return (
            <div className={styles.page}>
                <p className={`innocode-typography--body-md-reading innocode-typography--medium ${styles.verifying_text}`}>
                    {message}
                </p>
            </div>
        );
    }

    if (authStatus === 'SUCCESS') {
        return (
            <div className={styles.page}>
                <div className={styles.content}>
                    <div className={styles.icon_group}>
                        <div className={styles.icon_box}>
                            <img src="/assets/auth_success-icon.svg" alt="" className={styles.icon} />
                        </div>
                        <h1 className={`innocode-typography--headline-lg innocode-typography--bold ${styles.title}`}>
                            인증을 완료했어요.
                        </h1>
                    </div>
                    <p className={styles.description}>
                        인증을 요청한 서비스에서 [인증확인] 버튼을 눌러주세요.
                    </p>
                </div>
            </div>
        );
    }

    if (authStatus === 'FAILURE') {
        return (
            <div className={styles.page}>
                <div className={styles.content}>
                    <div className={styles.icon_group}>
                        <div className={`${styles.icon_box} ${styles.icon_box_sm}`}>
                            <img src="/assets/auth_failure-icon.svg" alt="" className={styles.icon} />
                        </div>
                        <h1 className={`innocode-typography--headline-lg innocode-typography--bold ${styles.title}`}>
                            로그인에 실패했습니다.
                        </h1>
                    </div>
                    <p className={styles.description}>
                        {message}
                    </p>
                </div>
            </div>
        );
    }
};

export default AuthEmail;